/**
 * @name FleetService
 * @author Surjeet Bhadauriya <surjeet.bhadauriya@techifysolutions.com>
 * @description All APIs for fleet manager
 * @version 0.0.1
 */
import { request } from "./Request";
import { routes } from "../constants/constant.route";

const {
  GET_PENDING_OFFTAKE,
  GET_REJECT_REMARK,
  VERIFY_OFFTAKE,
  INDIRECT_BILLING_REPORT,
  INDIRECT_BILLING_REPORT_BY_MONTH,
  OFFTAKE_VERIFICATION_COUNT,
  OFFTAKE_SCORE_CARD_FLEET,
  GET_TOTAL_VEHICLES_TYRES,
  GET_TOTAL_VEHICLES_TYRES_BY_FLEET,
  GET_FLEET_PROFILE_DETAIL,
  GET_SUBSIDIARIES
} = routes.FLEET_MANAGER;
const { GET_OFFTAKE_BY_ID } = routes.OFFTAKE_ENTRY;
const { GET_FLEET_DATA } = routes.FLEET_REGISTRATION;
const API_URL = process.env.REACT_APP_API_URL;

export default class FleetManagerService {
  /**
   * @name getPendingOfftake
   * @description Get Pending Offtake
   * @param {q: Object}
   * @method GET
   * @returns promise
   */
  static getPendingOfftake(q) {
    let qp = `?status=${q.status}&download_report=${q.downloadReport}&page=${q.page}&pagesize=${q.pagesize}`;
    if (q.year) {
      qp += `&y=${q.year}`;
    }

    return request(
      "GET",
      `${API_URL}${GET_PENDING_OFFTAKE}${qp}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getOfftakeEntryById
   * @description getOfftakeEntryById
   * @param {data: Object}
   * @method POST
   * @returns promise
   */
  static getOfftakeEntryById(data) {
    return request("POST", `${API_URL}${GET_OFFTAKE_BY_ID}`, null, data, null);
  }

  /**
   * @name getFleetData
   * @description Get Fleet Data
   * @param {fleetId: String}
   * @method GET
   * @returns promise
   */
  static getFleetVehicleData(fleetId) {
    return request(
      "GET",
      `${API_URL}${GET_FLEET_DATA}?fleet=${fleetId}`,
      null,
      null,
      null
    );
  }

  static offtakeStatusUpdate(data) {
    return request("POST", `${API_URL}${VERIFY_OFFTAKE}`, null, data, null);
  }

  static getRejectRemark() {
    return request("GET", `${API_URL}${GET_REJECT_REMARK}`, null, null, null);
  }

  static getIndirectBillingReport(year, download_report) {
    let qp = "?";
    if (year) {
      qp += `y=${year}`;
    }
    if (download_report) {
      qp += `&download_report=true`;
    }

    return request(
      "GET",
      `${API_URL}${INDIRECT_BILLING_REPORT}${qp}`,
      null,
      null,
      null
    );
  }

  static getIndirectBillingReportMonthWise(q) {
    let qp = "?";
    if (q.monthId) {
      qp += `m=${q.monthId}`;
    }
    if (q.status && !q.monthId) {
      qp += `status=${q.monthId}`;
    } else if (q.status && q.monthId) {
      qp += `&status=${q.monthId}`;
    }
    if (q.page) {
      qp += `&page=${q.page}`;
    }
    if (q.pagesize) {
      qp += `&pagesize=${q.pagesize}`;
    }
    if (q.year) {
      qp += `&y=${q.year}`;
    }
    return request(
      "GET",
      `${API_URL}${INDIRECT_BILLING_REPORT_BY_MONTH}${qp}`,
      null,
      null,
      null
    );
  }

  static getOfftakeEntriesCount(year) {
    // let qp = `?`;
    // if (year) {
    //   qp += `y=${year}`;
    // }
    return request(
      "GET",
      `${API_URL}${OFFTAKE_VERIFICATION_COUNT}`,
      null,
      null,
      null
    );
  }

  static getOfftakeScorecardFleet(page = 1, limit = 10, search, uuid, year) {
    let qp = `page=${page}&limit=${limit}`;
    if (!!search) {
      qp += `&q=${search}`;
    }
    if (!!uuid) {
      qp += `&u=${uuid}`;
    }
    if (year) {
      qp += `&y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${OFFTAKE_SCORE_CARD_FLEET}?${qp}`,
      null,
      null,
      null
    );
  }

  static getTotalVehiclesAndTyres() {
    return request(
      "GET",
      `${API_URL}${GET_TOTAL_VEHICLES_TYRES}`,
      null,
      null,
      null
    );
  }

  static getTotalVehiclesAndTyresByFleet(q) {
    let qp = `?`;
    if (q.query) {
      qp += `q=${q.query}&`;
    }
    if (q.page) {
      qp += `page=${q.page}&`;
    }
    if (q.pagesize) {
      qp += `pagesize=${q.pagesize}&`;
    }
    if (!(q.isActive === null || q.isActive === undefined)) {
      qp += `is_active=${q.isActive}&`;
    }
    if (q.downloadReport) {
      qp += `download_report=${q.downloadReport}`;
    }
    return request(
      "GET",
      `${API_URL}${GET_TOTAL_VEHICLES_TYRES_BY_FLEET}${qp}`,
      null,
      null,
      null
    );
  }

  static getFleetProfileDetail(id) {
    return request(
      "GET",
      `${API_URL}${GET_FLEET_PROFILE_DETAIL}?id=${id}`,
      null,
      null,
      null
    );
  }

  static getSubsidiaries(isAll, id) {
    return request(
      "GET",
      `${API_URL}${GET_SUBSIDIARIES}?all=${isAll}&id=${id}`,
      null,
      null,
      null
    );
  }
}
